webpackJsonp([114276838955818,60335399758886],{

/***/ 195:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(309);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(195);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	module.exports = {
	  siteMetadata: {
	    title: 'hydrogen',
	    description: 'hydrogen Emulator Frontend',
	    siteUrl: 'https://hydrogen-app.com',
	    author: 'Ronny Chan',
	    twitter: 'chyyran',
	    adsense: ''
	  },
	  pathPrefix: '/',
	  plugins: [{
	    resolve: 'gatsby-source-filesystem',
	    options: {
	      path: __dirname + '/src/pages',
	      name: 'pages'
	    }
	  }, {
	    resolve: 'gatsby-transformer-remark',
	    options: {
	      plugins: [{
	        resolve: 'gatsby-remark-images',
	        options: {
	          maxWidth: 750,
	          linkImagesToOriginal: false,
	          wrapperStyle: 'margin-bottom: 1.0725rem;'
	        }
	      }, {
	        resolve: 'gatsby-remark-responsive-iframe',
	        options: {
	          wrapperStyle: 'margin-bottom: 1.0725rem'
	        }
	      }, 'gatsby-remark-prismjs', 'gatsby-remark-copy-linked-files', 'gatsby-remark-smartypants']
	    }
	  }, {
	    resolve: 'gatsby-plugin-manifest',
	    options: {
	      name: 'hydrogen',
	      short_name: 'hydrogen',
	      start_url: '/',
	      background_color: '#fff',
	      theme_color: '#9694ff',
	      display: 'minimal-ui',
	      icons: [{
	        src: '/img/pwa-192x192.png',
	        sizes: '192x192',
	        type: 'image/png'
	      }, {
	        src: '/img/pwa-512x512.png',
	        sizes: '512x512',
	        type: 'image/png'
	      }]
	    }
	  }, {
	    resolve: 'gatsby-plugin-google-analytics',
	    options: {
	      trackingId: ''
	    }
	  }, 'gatsby-plugin-catch-links', 'gatsby-plugin-netlify', 'gatsby-plugin-offline', 'gatsby-plugin-react-helmet', 'gatsby-plugin-react-next', 'gatsby-plugin-sass', 'gatsby-plugin-sharp', 'gatsby-plugin-sitemap', 'gatsby-plugin-twitter', 'gatsby-transformer-sharp']
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  // AMD
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory(root);
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node.js or CommonJS
	    module.exports = factory;
	  } else {
	    // Browser globals
	    root.emergence = factory(root);
	  }
	})(this, function(root) {
	
	  'use strict';
	
	  var emergence = {};
	  var poll, container, throttle, reset, handheld, elemCushion, offsetTop, offsetRight, offsetBottom, offsetLeft;
	  var callback = function() {};
	
	  // Browser feature test to include any browser APIs required for >= IE8
	  // @return {bool} true if supported, otherwise false
	  var cutsTheMustard = function() {
	    return 'querySelectorAll' in document ? true : false;
	  };
	
	  // Checks if user is on a handheld
	  // @return {bool} true if it's a handheld, otherwise false
	  var isHandheld = function() {
	    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|playbook|silk/i.test(
	      navigator.userAgent
	    );
	  };
	
	  // Get the offset of a DOM Element
	  // @param {DOMElement} elem the container or element
	  // @return {int} the top, left, width and height values in pixels
	  var getElemOffset = function(elem) {
	
	    // Width and height of container or element
	    var w = elem.offsetWidth;
	    var h = elem.offsetHeight;
	
	    // Default top and left position of container or element
	    var topPos = 0;
	    var leftPos = 0;
	
	    // Get total distance of container or element to document's top and left origin
	    do {
	      if (!isNaN(elem.offsetTop)) {
	        topPos += elem.offsetTop;
	      }
	      if (!isNaN(elem.offsetLeft)) {
	        leftPos += elem.offsetLeft;
	      }
	    } while ((elem = elem.offsetParent) !== null);
	
	    // Return dimensions and position
	    return {
	      width: w,
	      height: h,
	      top: topPos,
	      left: leftPos
	    };
	  };
	
	  // Get the custom container size if provided, otherwise the documents
	  // @return {int} the width and height in pixels
	  var getContainerSize = function(container) {
	    var w, h;
	
	    // If custom container is provided in options
	    // Else use window or document
	    if (container !== window) {
	      w = container.clientWidth;
	      h = container.clientHeight;
	    } else {
	      w = window.innerWidth || document.documentElement.clientWidth;
	      h = window.innerHeight || document.documentElement.clientHeight;
	    }
	
	    return {
	      width: w,
	      height: h
	    };
	  };
	
	  // Get the X and Y scroll positions
	  // @return {int} the X and Y values in pixels
	  var getContainerScroll = function(container) {
	
	    // If custom container is provided in options
	    // Else use window or document
	    if (container !== window) {
	      return {
	        x: container.scrollLeft + getElemOffset(container).left,
	        y: container.scrollTop + getElemOffset(container).top
	      };
	    } else {
	      return {
	        x: window.pageXOffset || document.documentElement.scrollLeft,
	        y: window.pageYOffset || document.documentElement.scrollTop
	      };
	    }
	  };
	
	  // Check if element's closest parent is hidden (display: none)
	  // @param {DOMElement} elem the element
	  // @return {bool} true if hidden, false otherwise
	  var isHidden = function(elem) {
	    return elem.offsetParent === null;
	  };
	
	  // Check if element is visible
	  // @param {DOMElement} elem the element
	  var isVisible = function(elem) {
	
	    // Discontinue if element's closest parent is hidden
	    if (isHidden(elem)) {
	      return false;
	    }
	
	    // Get information from element and container
	    var elemOffset = getElemOffset(elem);
	    var containerSize = getContainerSize(container);
	    var containerScroll = getContainerScroll(container);
	
	    // Determine element size
	    var elemWidth = elemOffset.width;
	    var elemHeight = elemOffset.height;
	
	    // Determine element position from rect points
	    var elemTop = elemOffset.top;
	    var elemLeft = elemOffset.left;
	    var elemBottom = elemTop + elemHeight;
	    var elemRight = elemLeft + elemWidth;
	
	    // Determine boundaries of container and element
	    // @return {bool} true if element is found within boundaries, otherwise false
	    var checkBoundaries = function() {
	
	      // Determine element boundaries including custom cushion
	      var eTop = elemTop + elemHeight * elemCushion;
	      var eRight = elemRight - elemWidth * elemCushion;
	      var eBottom = elemBottom - elemHeight * elemCushion;
	      var eLeft = elemLeft + elemWidth * elemCushion;
	
	      // Determine container boundaries including custom offset
	      var cTop = containerScroll.y + offsetTop;
	      var cRight = containerScroll.x - offsetRight + containerSize.width;
	      var cBottom = containerScroll.y - offsetBottom + containerSize.height;
	      var cLeft = containerScroll.x + offsetLeft;
	
	      return (eTop < cBottom && eBottom > cTop && eLeft < cRight && eRight > cLeft);
	    };
	
	    return checkBoundaries();
	  };
	
	  // Engage emergence through a throttling method for performance
	  var emergenceThrottle = function() {
	    if (!!poll) {
	      return;
	    }
	    clearTimeout(poll);
	    poll = setTimeout(function() {
	      emergence.engage();
	      poll = null;
	    }, throttle);
	  };
	
	  // Initialize emergence with options, do feature test and create event listeners
	  // @param {Object} options Custom settings
	  emergence.init = function(options) {
	    options = options || {};
	
	    // Function to return an integer
	    var optionInt = function(option, fallback) {
	      return parseInt(option || fallback, 10);
	    };
	
	    // Function to return a floating point number
	    var optionFloat = function(option, fallback) {
	      return parseFloat(option || fallback);
	    };
	
	    // Default options
	    container = options.container || window; // window or document by default
	    reset = typeof options.reset !== 'undefined' ? options.reset : true; // true by default
	    handheld = typeof options.handheld !== 'undefined' ? options.handheld : true; // true by default
	    throttle = optionInt(options.throttle, 250); // 250 by default
	    elemCushion = optionFloat(options.elemCushion, 0.15); // 0.15 by default
	    offsetTop = optionInt(options.offsetTop, 0); // 0 by default
	    offsetRight = optionInt(options.offsetRight, 0); // 0 by default
	    offsetBottom = optionInt(options.offsetBottom, 0); // 0 by default
	    offsetLeft = optionInt(options.offsetLeft, 0); // 0 by default
	    callback = options.callback || callback;
	
	    // If browser doesn't pass feature test
	    if (!cutsTheMustard()) {
	
	      // Provide message in console.log
	      console.log('Emergence.js is not supported in this browser.');
	
	    }
	    // If this is handheld device AND handheld option is true
	    // OR not a handheld device
	    else if ((isHandheld() && handheld) || !isHandheld()) {
	
	      // Add '.emergence' class to document for conditional CSS
	      document.documentElement.className += ' emergence';
	
	      // If browser supports addEventListener
	      // Else use attachEvent
	      if (window.addEventListener) {
	
	        // Add event listeners for load, scroll and resize events
	        window.addEventListener('load', emergenceThrottle, false);
	        container.addEventListener('scroll', emergenceThrottle, false);
	        container.addEventListener('resize', emergenceThrottle, false);
	
	      } else {
	
	        // Attach events for legacy load method, scroll and resize events
	        document.attachEvent('onreadystatechange', function() {
	          if (document.readyState === 'complete') { emergenceThrottle(); }
	        });
	        container.attachEvent('onscroll', emergenceThrottle);
	        container.attachEvent('onresize', emergenceThrottle);
	
	      }
	    }
	  };
	
	  // Engage emergence
	  emergence.engage = function() {
	    var nodes = document.querySelectorAll('[data-emergence]');
	    var length = nodes.length;
	    var elem;
	
	    // Loop through objects with data-emergence attribute
	    for (var i = 0; i < length; i++) {
	      elem = nodes[i];
	
	      // If element is visible
	      if (isVisible(elem)) {
	
	        // Change the state of the attribute to 'visible'
	        elem.setAttribute('data-emergence', 'visible');
	
	        // Hack to repaint attribute in IE8
	        elem.className = elem.className;
	
	        // Callback for when element is visible
	        callback(elem, 'visible');
	
	      } else if (reset === true) {
	
	        // Else if element is hidden and reset
	        // Change the state of the attribute to 'hidden'
	        elem.setAttribute('data-emergence', 'hidden');
	
	        // Hack to repaint attribute in IE8
	        elem.className = elem.className;
	
	        // Create callback
	        callback(elem, 'reset');
	
	      } else if (reset === false) {
	
	        // Else if element is hidden and NOT reset
	        // Create callback
	        callback(elem, 'noreset');
	
	      }
	    }
	    
	    // If no data-emergence attributes are found
	    // Disengage emergence
	    if (!length) {
	      emergence.disengage();
	    }
	  };
	
	  // Disengage emergence
	  emergence.disengage = function() {
	
	    // If browser supports removeEventListener
	    // Else use detachEvent
	    if (window.removeEventListener) {
	
	      // Remove event listeners scroll and resize events
	      container.removeEventListener('scroll', emergenceThrottle, false);
	      container.removeEventListener('resize', emergenceThrottle, false);
	
	    } else {
	
	      // Detach scroll and resize events
	      container.detachEvent('onscroll', emergenceThrottle);
	      container.detachEvent('onresize', emergenceThrottle);
	
	    }
	
	    // Clear timeout from throttle
	    clearTimeout(poll);
	  };
	
	  return emergence;
	});


/***/ }),

/***/ 395:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(60),
	    hashDelete = __webpack_require__(61),
	    hashGet = __webpack_require__(62),
	    hashHas = __webpack_require__(63),
	    hashSet = __webpack_require__(64);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(67),
	    listCacheDelete = __webpack_require__(68),
	    listCacheGet = __webpack_require__(69),
	    listCacheHas = __webpack_require__(70),
	    listCacheSet = __webpack_require__(71);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(4),
	    root = __webpack_require__(3);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(72),
	    mapCacheDelete = __webpack_require__(73),
	    mapCacheGet = __webpack_require__(74),
	    mapCacheHas = __webpack_require__(75),
	    mapCacheSet = __webpack_require__(76);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(3);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(28);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(38),
	    toKey = __webpack_require__(20);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(9),
	    getRawTag = __webpack_require__(57),
	    objectToString = __webpack_require__(78);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(33),
	    isMasked = __webpack_require__(66),
	    isObject = __webpack_require__(16),
	    toSource = __webpack_require__(32);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(9),
	    arrayMap = __webpack_require__(36),
	    isArray = __webpack_require__(2),
	    isSymbol = __webpack_require__(13);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(2),
	    isKey = __webpack_require__(27),
	    stringToPath = __webpack_require__(79),
	    toString = __webpack_require__(83);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(3);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(65);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(52),
	    getValue = __webpack_require__(59);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(9);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(12);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(12);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(12);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(12);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(2),
	    isSymbol = __webpack_require__(13);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),

/***/ 65:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(56);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(10);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(10);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(10);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(10);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(50),
	    ListCache = __webpack_require__(19),
	    Map = __webpack_require__(25);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(11);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(11);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(11);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(11);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(82);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(4);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),

/***/ 78:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(31);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(77);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(13);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),

/***/ 32:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),

/***/ 28:
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(37);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(5),
	    isObject = __webpack_require__(16);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(5),
	    isObjectLike = __webpack_require__(7);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(26);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(54);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),

/***/ 396:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(17);
	
	var _get2 = _interopRequireDefault(_get);
	
	__webpack_require__(459);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'footer',
	      { className: 'footer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container text-left' },
	        _react2.default.createElement(
	          'div',
	          null,
	          'Built with \u2764\uFE0F by ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/chyyran' },
	            '@chyyran'
	          ),
	          '. Text content licensed under CC-BY-SA 4.0.'
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SiteNavi = function (_React$Component) {
	  _inherits(SiteNavi, _React$Component);
	
	  function SiteNavi() {
	    _classCallCheck(this, SiteNavi);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SiteNavi.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        title = _props.title;
	
	    return _react2.default.createElement(
	      'header',
	      { className: 'navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar bg-primary' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'navbar-brand mr-0 mr-md-2', to: '/', 'aria-label': 'Snowflake' },
	        _react2.default.createElement('img', { src: '/svg/banner.svg', style: { height: 63, width: 300, pointerEvents: 'none', padding: 0, margin: 0 } })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-nav-scroll ml-md-auto' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'navbar-nav bd-navbar-nav' },
	          _react2.default.createElement(
	            'li',
	            {
	              className: location.pathname === '/' ? 'nav-item active' : 'nav-item'
	            },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/', className: 'nav-link' },
	              'Home'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            {
	              className: location.pathname.startsWith('/blog') || location.pathname === '/blog' ? 'nav-item active' : 'nav-item'
	            },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/blog', className: 'nav-link' },
	              'Blog'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            {
	              className: location.pathname === '/profile/' ? 'nav-item active' : 'nav-item'
	            },
	            _react2.default.createElement(
	              'a',
	              { className: 'nav-link', href: 'https://github.com/SnowflakePowered' },
	              'GitHub'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return SiteNavi;
	}(_react2.default.Component);
	
	exports.default = SiteNavi;
	module.exports = exports['default'];

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyConfig = __webpack_require__(302);
	
	var _SiteNavi = __webpack_require__(307);
	
	var _SiteNavi2 = _interopRequireDefault(_SiteNavi);
	
	var _emergence = __webpack_require__(392);
	
	var _emergence2 = _interopRequireDefault(_emergence);
	
	var _Footer = __webpack_require__(303);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(465);
	
	__webpack_require__(393);
	
	__webpack_require__(396);
	
	__webpack_require__(394);
	
	__webpack_require__(395);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    _emergence2.default.init();
	  };
	
	  Template.prototype.componentDidUpdate = function componentDidUpdate() {
	    _emergence2.default.init();
	  };
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_SiteNavi2.default, _extends({ title: _gatsbyConfig.siteMetadata.title }, this.props)),
	      children(),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-d9020940e8ccb57a9945.js